import { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { getCotizacionesPropuestas, abrirCotizacionPDF } from '../../../../service/AffariService';
import LoaderTransparent from '../../../../components/ui/LoaderTransparent';



const PropuestasDialog = ({ visible, onCancel, codigo }) => {
    const [propuestas, setPropuestas] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!visible || !codigo) return;

        setLoading(true);
        setPropuestas([]);

        getCotizacionesPropuestas(codigo)
            .then((resp) => {
                const lista = Array.isArray(resp) ? resp : resp?.cotizaciones || [];
                setPropuestas(lista);
            })
            .catch((error) => {
                console.error('Error obteniendo propuestas del cliente:', error);
            })
            .finally(() => setLoading(false));
    }, [visible, codigo]);

    const formatCurrency = (value) => {
        if (value === null || value === undefined) return '';
        return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(value);
    };

    const rowClassName = (rowData) => {
        return rowData?.borrador ? 'bg-yellow-100' : '';
    };

    return (
        <Dialog
            header={`Propuestas`}
            visible={visible}
            className="p-fluid custom-dialog"
            modal
            onHide={onCancel}
            dismissableMask={true}
        >
            {loading && <LoaderTransparent coverParent overlayTint="transparent" />}
            <DataTable
                value={propuestas}
                tableStyle={{ minWidth: "50rem" }}
                size="small"
                paginator
                rows={10}
                rowsPerPageOptions={[10, 20, 50, 100]}
                dataKey="id"
                filterDisplay="row"
                className="p-datatable-sm border-1 surface-border border-round"
                globalFilterFields={["cliente.razonSocial"]}
                stripedRows
                rowHover                              // resalta filas al hover
                showGridlines                         // muestra líneas de cuadrícula
                sortMode="multiple"                   // orden múltiple por columnas
                removableSort                         // permite limpiar orden
                resizableColumns                      // permitir redimensionar columnas
                columnResizeMode="fit"                // ajuste de columnas al redimensionar
                reorderableColumns                    // reordenar columnas arrastrando el header
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                scrollable={true}
                emptyMessage={<div className="p-4 hover:font-bold">No hay ningún registro que mostrar</div>}
                rowClassName={rowClassName}
            >
                <Column
                    columnKey="acciones"
                    header=""
                    body={(rowData) => (
                        <Button
                            icon="pi pi-search"
                            className="p-button-rounded p-button-text p-button-secondary p-button-sm"
                            onClick={() => abrirCotizacionPDF(rowData?.id)}
                        />
                    )}
                    style={{ width: '3rem' }}
                />
                <Column
                    columnKey="folio"
                    field="folio"
                    header="Folio"
                    style={{ width: '6rem' }}
                    sortable
                />
                <Column
                    columnKey="fecha"
                    header="Fecha"
                    body={(rowData) => rowData?.fechaf || rowData?.fecha || ''}
                    style={{ width: '8rem' }}
                    sortable
                />
                <Column
                    columnKey="tipo"
                    field="tipo"
                    header="Tipo"
                    sortable
                />
                <Column
                    columnKey="estado"
                    field="estado"
                    header="Estado"
                    sortable
                />
                <Column
                    columnKey="vendedor"
                    field="vendedor"
                    header="Vendedor"
                    sortable
                />
                <Column
                    columnKey="total"
                    field="total"
                    header="Monto"
                    body={(rowData) => formatCurrency(rowData?.total)}
                    style={{ textAlign: 'right', width: '8rem' }}
                    sortable    
                />
            </DataTable>
        </Dialog>
    );
};

export default PropuestasDialog;
